// extracted by mini-css-extract-plugin
export default {"root":"SDSVjX","image":"cxpDrL","svg":"nTYCEx"};